import strFunc from "@/lib/lyg/string";

function SumPointArea(props: any) {
  let myProps = {
    listOpt: {},
    countInfo: { tot: 0 },
    point_tot_info: {
      in_money: 0,
      out_money: 0,
      in_debt: 0,
      out_debt: 0,
      tot: 0
    },
    ...props
  };
  let listOpt= myProps.listOpt;
  let countInfo= myProps.countInfo;
  let point_tot_info = myProps.point_tot_info;
  let count_remain_point=0;
  if(point_tot_info){
    let tmp_in_money=strFunc.uncomma_int(countInfo.row_view_money_in);
    let tmp_out_money=strFunc.uncomma_int(countInfo.row_view_money_out);
    count_remain_point=tmp_in_money - tmp_out_money;
  }

  return (
    <div className="flex justify-end mb-3">
      <div className="bg-gray-50 rounded-lg shadow-sm border border-gray-200 px-4 py-2">
        <table className="table-auto">
          <tbody>
            <tr className="text-sm">
              <th>총합</th>
              <td className="px-2 py-1 text-gray-600 font-medium">충전</td>
              <td className="px-2 py-1 text-right text-blue-600 font-semibold min-w-[80px]">
                {strFunc.comma(point_tot_info.in_money)}원
              </td>
              <td className="px-2 py-1 text-gray-600 font-medium border-l border-gray-300">사용</td>
              <td className="px-2 py-1 text-right text-red-600 font-semibold min-w-[80px]">
                {strFunc.comma(point_tot_info.out_money)}원
              </td>
              <td className="px-2 py-1 text-gray-700 font-bold border-l border-gray-300">남은포인트</td>
              <td className="px-2 py-1 text-right text-green-600 font-bold min-w-[80px]">
                {strFunc.comma(point_tot_info.tot)}원
              </td>
            </tr>
            <tr className="text-xs border-t border-gray-200 bg-indigo-50/40">
              <th className="text-gray-700 font-semibold pt-2">{listOpt.s_start_date.substring(5, 7)}월</th>
              <td className="px-2 py-1 pt-2 text-gray-600 font-medium">충전</td>
              <td className="px-2 py-1 pt-2 text-right text-blue-600 font-medium min-w-[80px]">
                {strFunc.comma(countInfo.row_view_money_in)}원
              </td>
              <td className="px-2 py-1 pt-2 text-gray-600 font-medium border-l border-gray-300">사용</td>
              <td className="px-2 py-1 pt-2 text-right text-rose-600 font-medium min-w-[80px]">
                {strFunc.comma(countInfo.row_view_money_out)}원
              </td>
              <td className="px-2 py-1 pt-2 text-gray-700 font-bold border-l border-gray-300">월 합계</td>
              <td className="px-2 py-1 pt-2 text-right text-emerald-600 font-medium min-w-[80px]">
                {strFunc.comma(count_remain_point)}원
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default SumPointArea;